import React, { useEffect, useState } from 'react';
import Planning from './Planning';
import './styles/planning.css';
import { Link } from 'react-router-dom';

const MiddleSection = ({ data }) => {
  const [scrollOffset, setScrollOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Simple parallax: move sidebar slower than scroll
      // Limit the movement to a reasonable range
      const maxOffset = 0; // Maximum pixels to move - reduced to prevent footer overlap
      const offset = Math.min(scrollY * 0.08, maxOffset);

      setScrollOffset(offset);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className='financial-container'>
      <div className='content-wrapper'>
        <Planning data={data} />
        <div className='sidebar-wrapper'>
          <div className='sidebar' style={{ transform: `translateY(${scrollOffset}px)` }}>
            <div className='sidebar-box'>
              <h3>{data?.sidebarTitle || 'Ready To Get Started?'}</h3>
              <p>
                {data?.sidebarText ||
                  'Talk to one of our friendly home loan experts to understand your borrowing capacity and incentives available to you.'}
              </p>
              <Link to='/contact' className='btn btn-hero-primary'>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiddleSection;
